import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2, Pencil, Check } from "lucide-react";
import api from "../api";
import { uploadImage } from "../media";
import { SecureImg } from "./SecureImg";
import { EditProfileDialog } from "./EditProfileDialog";

export const ProfileHeader = ({ user, onSaved }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user.name || "");
  const photo = user.profile_picture || user.picture;

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const url = await uploadImage(f, "private");
      await api.patch("/auth/me", { profile_picture: url });
      toast.success("Foto atualizada"); onSaved();
    } catch (err) { toast.error(err.response?.data?.detail || "Falha ao enviar foto"); }
    finally { setBusy(false); }
  };
  const saveName = async () => {
    if (!name.trim()) return toast.error("Informe seu nome");
    await api.patch("/auth/me", { name: name.trim() });
    setEditing(false); toast.success("Nome atualizado"); onSaved();
  };

  return (
    <div className="flex items-center gap-4">
      <button onClick={() => ref.current?.click()} className="relative w-20 h-20 rounded-full overflow-hidden border-2 border-[color:var(--sun-500)] shrink-0 group" data-testid="profile-photo-btn">
        {photo ? <SecureImg src={photo} alt={user.name} className="w-full h-full object-cover"/>
               : <div className="w-full h-full grid place-items-center bg-[var(--cream-100)] font-serif text-3xl text-[color:var(--sun-700)]">{(user.name || "?")[0]}</div>}
        <span className="absolute inset-0 grid place-items-center bg-black/35 text-white opacity-0 group-hover:opacity-100 transition-opacity">
          {busy ? <Loader2 size={18} className="animate-spin"/> : <Camera size={18}/>}
        </span>
      </button>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid="profile-photo-input"/>
      <div>
        <div className="tag-sun mb-2 inline-block">CLUBE ARYA</div>
        {editing ? (
          <div className="flex items-center gap-2">
            <input value={name} onChange={e => setName(e.target.value)} className="rounded-xl border border-[var(--line)] bg-white px-3 py-1.5 text-lg font-serif" data-testid="profile-name-input"/>
            <button onClick={saveName} className="p-2 rounded-full bg-[var(--sun-500)] text-white" data-testid="profile-name-save"><Check size={14}/></button>
          </div>
        ) : (
          <h1 className="font-serif text-3xl flex items-center gap-2" data-testid="profile-name">
            {user.name || "cliente"}
            <button onClick={() => setEditing(true)} className="p-1 text-[color:var(--sun-700)]" data-testid="profile-name-edit"><Pencil size={14}/></button>
          </h1>
        )}
        <p className="text-sm text-[color:var(--ink-500)] mt-1">{user.email}</p>
        <EditProfileDialog user={user} onSaved={onSaved}/>
      </div>
    </div>
  );
};
